// extracted by mini-css-extract-plugin
module.exports = {"organism__accessory-single-container":"styles_organism__accessory-single-container__ZtI4S","tasa-legal-text":"styles_tasa-legal-text__pMcFP"};